<template>
    <mvtInputGeo class="default large" v-if="loaded" placeholder="Search by Neighborhood, City, Address, ZIP" v-model="geoInfo">
        Find an Agent
    </mvtInputGeo>
</template>
<script src="./agent-inputgeo.js"></script>
<style lang="scss">
@use './agent-inputgeo.scss' as *;
</style>